import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  types: [],
  regions: [],
  categories: [],
  items: [],
  status: 'idle',
  error: null
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    menuFetchStart(state) {
      state.status = 'loading';
      state.error = null;
    },
    menuFetchSuccess(state, action) {
      state.status = 'succeeded';
      Object.assign(state, action.payload);
    },
    menuFetchFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    setMenuItems(state, action) {
      state.items = action.payload;
    }
  }
});

export const { menuFetchStart, menuFetchSuccess, menuFetchFailure, setMenuItems } = menuSlice.actions;
export default menuSlice.reducer;
